import { ICar } from '../..';

export const CARS_JAGUAR: ICar[] = [
  {
    value: 'JaguarIPace',
    caption: 'Jaguar I-Pace',
    icon: 'jaguar-i-pace.jpg',
  },
];
